<template>
  <button
    class="pr-8 pl-2 mr-8 lg:hidden focus:outline-none"
    @click="toggleMobileNavbar"
  >
    <i class="far fa-lg align-middle fa-fw fa-bars"></i>
  </button>
</template>
<script>
export default {
  props: {
    isOpen: Boolean,
  },

  methods: {
    toggleMobileNavbar() {
      window.TheNavbarMobilePanel.show()
    }
  }
}
</script>
